import classNames from 'classnames';

export function ChatMessage({ entry }) {
  const isUser = entry.owner === 'user';
  const isTool = entry.kind === 'tool';
  const isError = entry.kind === 'error';

  return (
    <div className={classNames('flex', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className={classNames(
          'max-w-[78%] rounded-xl border px-4 py-3 text-sm shadow-sm',
          isUser && 'border-dodger-blue-500 bg-dodger-blue-500 text-white',
          !isUser && !isTool && !isError && 'border-mystic-500 bg-white text-body-500',
          isTool && 'border-solitude-500 bg-solitude-500 text-body-500',
          isError && 'border-carnation-500 bg-carnation-50 text-carnation-700',
        )}
      >
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide opacity-70">
          {isUser ? 'You' : isTool ? 'Tool' : 'Agent'}
        </div>
        <div className="whitespace-pre-wrap break-words">
          {entry.message || (entry.state === 'streaming' ? '…' : '')}
        </div>
        {entry.messageId ? (
          <div className="mt-2 break-all text-[11px] opacity-50">message_id: {entry.messageId}</div>
        ) : null}
      </div>
    </div>
  );
}
